import { render, staticRenderFns } from "./CommonsNavigation.vue?vue&type=template&id=3987bf70&scoped=true&"
import script from "./CommonsNavigation.vue?vue&type=script&lang=js&"
export * from "./CommonsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CommonsNavigation.vue?vue&type=style&index=0&id=3987bf70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987bf70",
  null
  
)

export default component.exports